import {
    EDIT_IN_ME,
    FETCH_ME,
    FETCH_ME_FAIL,
    FETCH_ME_SUCCESS,
    PATCH_COMPANY,
    PATCH_COMPANY_FAIL,
    PATCH_COMPANY_SUCCESS,
    PATCH_ME,
    PATCH_ME_FAIL,
    PATCH_ME_SUCCESS,
    SIGN_ME_UP,
    SIGN_ME_UP_FAIL,
    SIGN_ME_UP_SUCCESS,
} from './reducer';

export const editInMe = (path) => (value) => ({
    path,
    type: EDIT_IN_ME,
    value,
});

export const fetchMe = () => ({
    payload: {
        request: {
            params: {
                embeds: 'company.activeSubscription',
                withBalance: 1,
            },
            url: '/me',
        },
    },
    types: [FETCH_ME, FETCH_ME_SUCCESS, FETCH_ME_FAIL],
});

export const patchMe = (id, data) => {
    return {
        payload: {
            request: {
                data,
                method: 'patch',
                params: { embeds: 'company.activeSubscription' },
                url: `/users/${id}`,
            },
        },
        types: [PATCH_ME, PATCH_ME_SUCCESS, PATCH_ME_FAIL],
    };
};

export const patchCompany = (id, data) => ({
    payload: {
        request: {
            data,
            method: 'patch',
            url: `/companies/${id}`,
        },
    },
    types: [PATCH_COMPANY, PATCH_COMPANY_SUCCESS, PATCH_COMPANY_FAIL],
});

export const signup = (fields) => ({
    payload: {
        request: {
            data: {
                email: fields.get('email'),
                password: fields.get('password'),
                passwordRepeat: fields.get('passwordRepeat'),
            },
            method: 'post',
            url: '/users'
        },
    },
    types: [SIGN_ME_UP, SIGN_ME_UP_SUCCESS, SIGN_ME_UP_FAIL],
});



// WEBPACK FOOTER //
// ./src/redux/me/actions.js